import React from 'react';
import Image from '../../pics';
// import { Link } from 'react-router-dom';

function services() {
  return (
    <div>
        <div className="uk-section bg-primary">
            <div className="uk-container">
                <h2 className="text-primary uk-text-center">
                    Services
                </h2>
                <div className="uk-child-width-1-4@m uk-grid-small uk-grid-match" data-uk-grid>
                    <div>
                        <div className="uk-card uk-card-default uk-card-body">
                            <img src={Image.DOMESTIC} alt='domestic courier' width="100%" height="100%"/>
                            <h4 className="text-primary">
                                Domestic Courier 
                            </h4>
                            <p className='uk-text-justify text-secondary'>
                                From small sample parcels to small commercial shipments, our domestic courier service ensures swift and reliable delivery to many destination across India.
                            </p>
                        </div>
                    </div>
                    <div>
                        <div className="uk-card uk-card-default uk-card-body">
                            <img src={Image.D2DCARGO} alt='door to door' width="100%" height="100%"/>
                            <h4 className="text-primary">
                                Door to Door Air Cargo
                            </h4>
                            <p className='uk-text-justify text-secondary'>
                                Need to transport your bulk goods quicker to your clients? Our Door to door air cargo services guarantee efficient delivery, providing businesses with the speed and reliability they require.
                            </p>
                        </div>
                    </div>
                    <div>
                        <div className="uk-card uk-card-default uk-card-body">
                            <img src={Image.SAMEDAY} alt='same day' width="100%" height="100%"/>
                            <h4 className="text-primary">
                                Critical Same Day
                            </h4>
                            <p className='uk-text-justify text-secondary'>
                                Stratos provides same-day delivery for critical Shipments, Our efficient customer care is always available to address inquiries or concerns and ensuring your urgent shipments reach their destination promptly.
                            </p>
                        </div>
                    </div>
                    <div>
                        <div className="uk-card uk-card-default uk-card-body">
                            <img src={Image.CHARTED} alt='charter flight' width="100%" height="100%"/>
                            <h4 className="text-primary">
                                Cargo Charter Flight 
                            </h4>
                            <p className='uk-text-justify text-secondary'>
                                For larger shipments or time-sensitive deliveries, our Agreed charter flight service offer a flexible and efficient solution tailored to your specific needs with Insurance Climbs for Ton ranged Goods.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="uk-margin-top">
                    <a href='tel:+917300674006'>
                        <button>
                            Call Us
                        </button>
                    </a>
                </div>
            </div>
        </div>
    </div>
  )
}

export default services